import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Heading, Stack } from "@chakra-ui/react";
import type { ReactNode } from "react";
import type { FooterLinksCategoryType } from "../../types";

export const FooterLinksCategory = ({
  footerLinksCategoryName,
  footerLinksCategoryDirection: linksAlignment,
  children,
}: Pick<FooterLinksCategoryType, "footerLinksCategoryDirection" | "footerLinksCategoryName"> & {
  children: ReactNode;
}) => {
  if (!footerLinksCategoryName)
    return (
      <Stack px={8} spacing={{ base: 5, xl: "unset" }} direction={linksAlignment}>
        {children}
      </Stack>
    );

  return (
    <AccordionItem>
      <AccordionButton px={8} py={6} bg="greyscale.300" _expanded={{ bg: "white" }}>
        <Heading
          as="h4"
          flex="1"
          textAlign="left"
          textTransform="uppercase"
          fontSize="xs"
          fontWeight="medium"
          data-testid="footer-category"
        >
          {footerLinksCategoryName}
        </Heading>
        <AccordionIcon boxSize={6} color="primary.500" />
      </AccordionButton>
      <AccordionPanel px={8} pb={5} pt={0} bg="white">
        <Stack spacing={6} pb={3} pt={1} direction="column">
          {children}
        </Stack>
      </AccordionPanel>
    </AccordionItem>
  );
};
